import { render, staticRenderFns } from "./qualificationReview.vue?vue&type=template&id=0152b823&scoped=true"
import script from "./qualificationReview.vue?vue&type=script&lang=js"
export * from "./qualificationReview.vue?vue&type=script&lang=js"
import style0 from "./qualificationReview.vue?vue&type=style&index=0&id=0152b823&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152b823",
  null
  
)

export default component.exports